import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Buildings, Location, Messages2, People } from "iconsax-react";
import "./companypage.css";

  const Gstform = () => {
  const navigate = useNavigate();
  const gstData = useSelector((state) => state.gst.data?.data);
  
    if (!gstData) {
     return <h4 className="text-center mt-5">No GST Data Found. Please enter a GST Number.</h4>;
    }
  
     const handleProceed = () => {
     navigate("/companyPage", { state: { gstData } });
     };

    return (
    <div className="gst-container">
      <h2 className="gst-heading">GST Details</h2>
      <div className="gst-card">
        <div className="gst-item">
          <span><Buildings size="25" color="#007bff" variant="Bulk" /></span>
          <span className="txt_title">{gstData.legal_name_of_business || "N/A"}</span>
        </div>

        <div className="gst-item">
          <span><People size="25" color="#007bff" variant="Bulk" /></span>
          <span className="txt_title">{gstData.constitution_of_business || "N/A"}</span>
        </div>

        <div className="gst-item">
          <span><Messages2 size="25" color="#007bff" variant="Bulk" /></span>
          <span className="txt_title">{gstData.GSTIN || "N/A"}</span>
        </div>

        <div className="gst-item">
          <span><Location size="25" color="#007bff" variant="Bulk" /></span>
          <span className="txt_title">{gstData.principal_place_address || "N/A"}</span>
        </div>

        <button className="gst-button" onClick={handleProceed}>Proceed</button>
      </div>
    </div>
  );
};

export default Gstform;
